export default __webpack_public_path__ + "static/media/3233 knife block A top.a8909c80.png";